import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { SidebarService } from '../../services/sidebar.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environments/environment';

@Component({
	selector: 'app-sidebar',
	templateUrl: './sidebar.component.html',
	styleUrls: ['./sidebar.component.scss']
})

/**
 * (c) it.x informationssysteme gmbh, Alle Rechte vorbehalten.
 *
 * Sidebar Component.
 */
export class SidebarComponent implements OnInit, OnDestroy
{
	/**
	 * Environment.
	 */
	public environment = environment;

	/**
	 * Subscripton for the sidebar service.
	 */
	private sidebarSubscription: Subscription;

	/**
	 * State: Is the sidebar open?.
	 */
	public sidebarIsOpened = false;

	/**
	 * Last update.
	 */
	public lastUpdate: any;

	/**
	 * Languages.
	 */
	public languages: any[];

	/**
	 * Constructor.
	 */
	public constructor(
		private sidebarService: SidebarService,
		private translateService: TranslateService
	)
	{}

	/**
	 * Lifecycle-Hook: OnInit.
	 */
	public ngOnInit()
	{
		this.sidebarSubscription = this.sidebarService.sidebarIsOpened.subscribe(
			(status) => this.sidebarIsOpened = status
		);

		// Last update.
		const lastUpdate = localStorage.getItem('LAST_UPDATE');

		if (lastUpdate)
		{
			this.lastUpdate = {
				'date': moment(lastUpdate).format('DD.MM.YYYY'),
				'time': moment(lastUpdate).format('HH:mm')
			};
		}

		// Languages.
		this.languages = this.translateService.getLangs();
	}

	/**
	 * Lifecycle-Hook: OnDestroy.
	 */
	public ngOnDestroy()
	{
		this.sidebarSubscription.unsubscribe();
	}

	/**
	 * Sets the language.
	 */
	public setLanguage(language: string)
	{
		this.translateService.use(language);
	}

	/**
	 * Checks if a language is the current language.
	 */
	public isActiveLanguage(language: string): boolean
	{
		return (this.translateService.currentLang == language);
	}
}



// WEBPACK FOOTER //
// /var/data/workspace/hess/hess_smart_city_web/src/app/components/sidebar/sidebar.component.ts